import { Pipe, PipeTransform } from '@angular/core';
import { SchemaService } from '../services/schema.service';
import { Subscription } from 'rxjs';

@Pipe({
  name: 'themeSwitch',
  pure: false // Set pure to false to trigger change detection on each change
})
export class ThemeSwitchPipe implements PipeTransform {
  private themeSubscription: Subscription;
  private currentTheme: string;

  constructor(private schemaService: SchemaService) {
    this.currentTheme = this.schemaService.getCurrentTheme();
    this.themeSubscription = this.schemaService.getCurrentThemeObservable().subscribe(theme => {
      this.currentTheme = theme;
    });
  }

  public transform(classNames: string): string {
    return this.convertClasses(classNames);
  }

  private convertClasses(classNames: string): string {
    return classNames.split(' ').map(className => {
      if (this.currentTheme === 'dark') {
        if (className.includes('-dark')) {
          return className.replace('-dark', '-light');
        } else if (className.includes('-light')) {
          return className.replace('-light', '-dark');
        } else if (className.includes('-white')) {
          return className.replace('-white', '-dark');
        }
      } else {
        if (className.includes('-dark')) {
          return className.replace('-light', '-dark');
        } else if (className.includes('-light')) {
          return className.replace('-dark', '-light');
        }
      }
      return className;
    }).join(' ');
  }

  ngOnDestroy() {
    this.themeSubscription.unsubscribe();
  }
}
